import CanvasStore from './store';
import React from 'react';
import CanvasInsertStore from './insert-store';

const CanvasContext = React.createContext(CanvasStore.empty());
const CanvasInsertContext = React.createContext(CanvasInsertStore.empty());
export {CanvasContext, CanvasInsertContext};